import { render, staticRenderFns } from "./VendorLayout.vue?vue&type=template&id=3d85ac37"
import script from "./VendorLayout.vue?vue&type=script&lang=js"
export * from "./VendorLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports